// src/pages/Careers.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Careers() {
  const [activeTab, setActiveTab] = useState("openings");
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ When Careers page loads, check if ?tab= is present
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      setActiveTab(tab); // set tab directly from query param
    }
  }, [location.search]);

  const jobs = [
    { id: 1, title: "Senior Software Engineer", location: "Hyderabad, India", type: "Full-Time", description: "Lead development of scalable enterprise applications." },
    { id: 2, title: "Senior Software Engineer", location: "Bangalore, India", type: "Full-Time", description: "Work on cloud-native applications and microservices." },
    { id: 3, title: "Software Engineer", location: "Remote", type: "Full-Time", description: "Develop and maintain ReactJS/NodeJS applications." },
    { id: 4, title: "Weblogic Administrator", location: "Chennai, India", type: "Full-Time", description: "Manage WebLogic servers and middleware deployments." },
    { id: 5, title: "Tuxedo Administrator", location: "Pune, India", type: "Full-Time", description: "Handle Oracle Tuxedo environments and support systems." },
    { id: 6, title: "VMWare Expert", location: "Hyderabad, India", type: "Full-Time", description: "Maintain virtualization infrastructure and performance." },
    { id: 7, title: "Tibco Architect", location: "Bangalore, India", type: "Full-Time", description: "Design and implement Tibco middleware solutions." },
    { id: 8, title: "Linux Administrator", location: "Remote / India", type: "Full-Time", description: "Manage Linux servers, security patches, and automation." },
  ];

  const internships = [
    { id: 1, title: "Frontend Developer Intern", location: "Remote / India", type: "Internship (3 Months)", description: "Work on real-world ReactJS applications with guidance from senior developers." },
    { id: 2, title: "Data Science Intern", location: "Hyderabad, India", type: "Internship (6 Months)", description: "Assist in building ML models, cleaning data, and deploying analytics dashboards." },
  ];

  const trainings = [
    { id: 1, title: "Cloud Computing Bootcamp", duration: "6 Weeks", description: "Hands-on AWS, Azure, and Google Cloud training with certification guidance." },
    { id: 2, title: "Full Stack Developer Program", duration: "8 Weeks", description: "Learn MERN stack (MongoDB, Express, React, NodeJS) with live projects." },
    { id: 3, title: "Cybersecurity Fundamentals", duration: "4 Weeks", description: "Introduction to network security, ethical hacking, and threat analysis." },
  ];

  // Function to handle Apply/Enroll click
  const handleApply = (job) => {
    navigate("/apply", { state: { job } });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: window.innerWidth < 768 ? "column" : "row",
        backgroundColor: "#fff",
        minHeight: "100vh",
      }}
    >
      {/* Sidebar */}
      <div
        style={{
          flex: "0 0 220px",
          backgroundColor: "#f1f5f9",
          padding: "20px",
          borderRight: "1px solid #ddd",
        }}
      >
        <h3 style={{ marginBottom: "20px", color: "#004080" }}>Careers</h3>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <li
            style={{
              marginBottom: "10px",
              cursor: "pointer",
              fontWeight: activeTab === "openings" ? "bold" : "normal",
              color: activeTab === "openings" ? "#0073e6" : "#333",
            }}
            onClick={() => setActiveTab("openings")}
          >
            Current Openings
          </li>
          <li
            style={{
              marginBottom: "10px",
              cursor: "pointer",
              fontWeight: activeTab === "internship" ? "bold" : "normal",
              color: activeTab === "internship" ? "#0073e6" : "#333",
            }}
            onClick={() => setActiveTab("internship")}
          >
            Internship Opportunities
          </li>
          <li
            style={{
              marginBottom: "10px",
              cursor: "pointer",
              fontWeight: activeTab === "training" ? "bold" : "normal",
              color: activeTab === "training" ? "#0073e6" : "#333",
            }}
            onClick={() => setActiveTab("training")}
          >
            Training
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, padding: "30px" }}>
        {activeTab === "openings" && (
          <>
            <h2 style={{ marginBottom: "20px", color: "#004080" }}>
              Following are the Current Job Openings
            </h2>
            {jobs.map((job) => (
              <div
                key={job.id}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "15px",
                  marginBottom: "15px",
                  backgroundColor: "#fafafa",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                }}
              >
                <h3 style={{ margin: "0 0 8px 0", color: "#e60000" }}>
                  {job.id}. {job.title}
                </h3>
                <p>
                  <strong>Location:</strong> {job.location}
                </p>
                <p>
                  <strong>Type:</strong> {job.type}
                </p>
                <p>{job.description}</p>
                <button
                  style={{
                    backgroundColor: "#004080",
                    color: "#fff",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleApply(job)}
                >
                  Apply Now
                </button>
              </div>
            ))}
          </>
        )}

        {activeTab === "internship" && (
          <>
            <h2 style={{ marginBottom: "20px", color: "#004080" }}>
              Internship Opportunities
            </h2>
            {internships.map((intern) => (
              <div
                key={intern.id}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "15px",
                  marginBottom: "15px",
                  backgroundColor: "#fafafa",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                }}
              >
                <h3 style={{ margin: "0 0 8px 0", color: "#006600" }}>
                  {intern.id}. {intern.title}
                </h3>
                <p>
                  <strong>Location:</strong> {intern.location}
                </p>
                <p>
                  <strong>Type:</strong> {intern.type}
                </p>
                <p>{intern.description}</p>
                <button
                  style={{
                    backgroundColor: "#28a745",
                    color: "#fff",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleApply(intern)}
                >
                  Apply Now
                </button>
              </div>
            ))}
          </>
        )}

        {activeTab === "training" && (
          <>
            <h2 style={{ marginBottom: "20px", color: "#004080" }}>
              Training Programs
            </h2>
            {trainings.map((training) => (
              <div
                key={training.id}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "15px",
                  marginBottom: "15px",
                  backgroundColor: "#fafafa",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                }}
              >
                <h3 style={{ margin: "0 0 8px 0", color: "#800080" }}>
                  {training.id}. {training.title}
                </h3>
                <p>
                  <strong>Duration:</strong> {training.duration}
                </p>
                <p>{training.description}</p>
                <button
                  style={{
                    backgroundColor: "#800080",
                    color: "#fff",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleApply(training)}
                >
                  Enroll Now
                </button>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

export default Careers;
